import React from 'react';
import ProtectedApp from './ProtectedApp';
import './App.css';

function App() {
  return <ProtectedApp />;
}

export default App;